import { SchoolEvent } from "./school-event";
import { Homework } from "../../homeworks/models/homework";

export class DatewiseEvents {
    public event_date: string;
    public general_events: Array<SchoolEvent>;
    public time_table: Array<SchoolEvent>;
    public holidays: Array<SchoolEvent>;
    public exams: Array<SchoolEvent>;
    public is_holiday: boolean;
    public has_events: boolean;
    public home_works: Array<Homework>;
    public homeworks_assigned: Array<Homework>;
    public homeworks_to_be_submitted: Array<Homework>;
}